import {Service} from '../common/service.class';
import M = Service.InjectedMembers;

/**
 * Created by Rodrigo Quesada on 09/12/16.
 */
export abstract class InfoService extends Service {

    constructor(svcm: M, namespace: string) {
        super(svcm, `info/${namespace}`);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/info/section-service.class.ts